import CONNECT_KZ from '@/graphql/Website/Integrations/KiziNL/ConnectKiziNLIntegration.gql';
import { authClient } from '../main'

export default class KiziNLResource {
    async connect (websiteId) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: CONNECT_KZ,
            variables: {
                websiteId: websiteId,
            }
        })
    }
}
